<template>
   <div v-if="initialize">
      <b-card class="mb-3">
         <Payment ref="payment" :currency="currency" />

         <template #header><b>{{ $t("visit-information-form.payment") }}</b></template>

         <div class="form-group row" v-if="!confirm">
            <div class="col-sm-12 pl-3 ml-1">
               <OptIn v-if="showOpt">
                  <template #settlement>
                     <input v-model="settlement" class="form-check-input" :disabled="payment_authorized" type="checkbox"
                        value="" id="disclosureCheck">
                     <label class="form-check-label" for="disclosureCheck">
                        {{ $t('visit-information-form.settlement_sentence') }}
                     </label>
                  </template>
               </OptIn>
         
               <input v-model="payment.gateway" :value="payment_gateway.digital_garage" type="radio"
                  @change="changePaymentMethod($event)" id="payDigitalGarage" name="payment_method" />
               <label class="form-check-label ml-2 text-decoration-none" for="payDigitalGarage">
                  {{ $t("visit-information-form.card_payment") }}
               </label>
            </div>
         </div>

         <div v-if="payment.gateway === payment_gateway.digital_garage">
            <PaymentButton :isPaidAuthorize="payment_authorized" :confirm="confirm" :showAlert="paymentAlert"
               type="button" @click="showModal" :paymentButtonText="paymentButtonText" :disabledBy="!settlement" />

            <!-- <button
               v-if="!payment_authorized"
               type="button"
               class="btn btn-primary btn-w-lg mx-auto payment-btn"
               @click="showModal"
               :disabled="settlement == false"
            >
               {{ $t("visit-information-form.start_payment") }}
            </button>

            <button v-else
               type="button"
               class="btn btn-primary btn-w-lg mx-auto authorized-btn"
               disabled
            >
               {{ $t("visit-information-form.card_authorized") }}
            </button> -->
         </div>

         <!-- pay at hotel -->
         <div class="form-group row" v-if="!confirm && payment_authorized === false">
            <div class="col-sm-12 pl-3 ml-1" v-if="payment_timing_opt.payHotelVisibility">
               <input v-model="payment.gateway" :value="payment_gateway.reception" type="radio"
                  @change="changePaymentMethod($event)" id="payHotel" name="payment_method" />
               <label class="form-check-label ml-2 text-decoration-none" for="payHotel">
                  {{ $t("visit-information-form.pay_at_reception") }}
               </label>
               <p v-if="payment.gateway == payment_gateway.reception" class="mb-0" style="color: #1a5dab">
                  {{ $t("visit-information-form.pay_at_reception_note") }}
               </p>
            </div>
         </div>

         <!-- paylater -->
         <div class="form-group row" v-if="!confirm && payment_authorized === false">
            <div class="col-sm-12 pl-3 ml-1" v-if="showPayLater">
               <input v-model="payment.gateway" :value="payment_gateway.payLater" type="radio"
                  @change="changePaymentMethod($event)" id="payLater" name="payment_method" />
               <label class="form-check-label ml-2 text-decoration-none" for="payLater">
                  {{ $t("visit-information-form.pay_later") }}
               </label>
               <p v-if="payment.gateway == payment_gateway.payLater" style="color: #1a5dab">
                  {{ $t("visit-information-form.pay_later_note") }}
               </p>
            </div>
         </div>

         <template v-if="confirm">
            <!-- <template v-if="payment.gateway == payment_gateway.digital_garage">
               <div class="form-group row">
                  <button type="button" class="btn btn-primary btn-w-lg mx-auto authorized-btn" disabled>
                  <template v-if="!challengeError">{{ $t("visit-information-form.card_authorized") }}</template>
<template
   v-if="challengeError"><span class="text-danger">{{ $t("visit-information-form.card_payment_error") }}</span></template>
</button>
</div>
</template> -->

            <div v-if="payment.gateway == payment_gateway.reception" class="form-group row">
               <label for="exampleInputEmail1" class="col-12 col-form-label">
                  {{ $t("visit-information-form.pay_at_reception") }}
               </label>
            </div>

            <div v-if="payment.gateway == payment_gateway.payLater" class="form-group row">
               <label for="exampleInputEmail1" class="col-12 col-form-label">
                  {{ $t("visit-information-form.pay_later") }}
               </label>
            </div>
         </template>

         <!-- Modal component -->
         <b-modal centered id="payment-modal" ref="paymentModal" :no-close-on-backdrop="true" :no-fade="true"
            :static="true" hide-footer :hide-header-close="allowCloseBtn">
            <iframe :src="`${iframeUrl}`" width="100%" height="500px" frameborder="0" allowfullscreen
               @load="iframeLoaded"></iframe>
         </b-modal>

         <!-- Session lock modal -->
         <b-modal
         centered
         id="session-lock-modal"
         ref="sessionLockModal"
         :no-close-on-backdrop="true"
         :no-fade="true"
         :static="true"
         hide-footer
         hide-header>
            <div class="p-4 text-center">
               <p>{{ $t('visit-information-form.digital_garage_card_session_lock') }}​</p>
               <b-button variant="danger" @click="reloadPage">{{ $t("visit-information-form.back") }}</b-button>
            </div>
         </b-modal>
      </b-card>


   </div>
</template>

<script>

import _typy from "typy";
import { mapActions, mapState, mapGetters } from "vuex";
import { payment_gateway, payment_status, booking_status } from "../../../utils/mockup";
import OptIn from "../components/OptIn.vue";
import Payment from '../components/Payment.vue';
import PaymentButton from "./PaymentButton.vue";
import { eventBus } from "@/main";

const pStatus = {
   error: {},
   status: true,
};

export default {
   components: {
      Payment,
      OptIn,
      PaymentButton
   },
   name: 'DigitalGaragePayment',
   props: [
      "booking_details",
      "facility",
      "confirm",
      "page",
      "currency",
      "touchdown",
      "settings"
   ],
   data() {
      return {
         initialize: false,
         dual_payment_mode: false,
         tokenizeCard: '',
         selectedPaymentMethod: null,
         slug_name: '',
         payment_authorized: false,
         show_payment: false,
         pStatus,
         payment: {
            gateway: payment_gateway.digital_garage,
            type: "card",
         },
         challengeError: false,
         payment_gateway,
         digital_garage_config: {
            token: process.env.VUE_APP_DIGITAL_GARAGE_TOKEN_API_KEY,
            name: payment_gateway.digital_garage,
            initialize: false,
            error: {},
         },
         payment_timing_opt: {
            payHotelVisibility: true,
            payLaterVisibility: false,
            waivePay: false,
         },
         isDeposit: false,
         isProcessing: false,
         settlement: false,
      };
   },
   async mounted() {
      window.addEventListener("beforeunload", this.beforeUnloadHandler);
      await this.showPaymentTimingOption();
      await this.showPayment();

      if (!this.show_payment) return;

      this.validatePayment();
   },
   beforeDestroy() {
      window.removeEventListener("beforeunload", this.beforeUnloadHandler);
   },
   methods: {
      ...mapActions("guest", ["setCheckoutFormEmpty", "setPaymentAlert"]),

      turnoffAlert() {
         console.log("trigger?");
         this.setPaymentAlert(false);
      },

      proceedToSubmit() {
         if (this.payment.gateway === this.payment_gateway.digital_garage && this.payment_authorized) {
            this.setPaymentAlert(true);
            return false;
         }

         this.setPaymentAlert(false);
         return true;
      },

      validateBeforeConfirm() {
         if (this.payment.gateway === this.payment_gateway.digital_garage && !this.payment_authorized) {
            this.setPaymentAlert(true);
            // setTimeout(() => {
            //    this.setPaymentAlert(false)
            // },3000)
            return false;
         }

         this.setPaymentAlert(false);
         return true;
      },
      beforeUnloadHandler(event) {
         if (this.payment_authorized) {
            event.preventDefault();
            event.returnValue = "";
         }
      },

      //  Trigger the modal to show card input form
      showModal() {
         this.$refs.paymentModal.show();
      },
      iframeLoaded() {
         window.addEventListener('message', this.handleMessageFromIframe);
      },
      handleMessageFromIframe(event) {
         if (event.data.action === 'closeModal') {
            this.payment_authorized = true;
            this.isProcessing = false;
            this.$refs.paymentModal.hide();
            this.tokenizeCard = event.data.tokenizeCard;
            this.setPaymentAlert(true);
            this.setCheckoutFormEmpty(false);
         } else if (event.data.action === 'startProcessing') {
            console.log('start process')
            this.isProcessing = true;
         } else if (event.data.action === 'endProcessing') {
            console.log('end process')
            this.isProcessing = false;
         } else if (event.data.action === 'sessionLock') {
            console.log('session lock')
            this.isProcessing = false;
            this.$refs.paymentModal.hide();
            this.$refs.sessionLockModal.show();
         }
      },
      async makePayment(messageToComponent) {
         let res;

         if (this.payment_gateway.payLater == this.payment.gateway) return true; // For pay later

         if (this.initialize) {
            if (this.payment.gateway == this.payment_gateway.digital_garage && this.payment_authorized) {
               const params = {
                  facility_id: this.settings.facility_id,
                  pms_code: this.settings.pms_code,
                  pms_reservation_no: this.settings.rsv_no,
                  pass: this.settings.pass,
                  entry_method: this.page == "checkout" ? 'postpaid' : 'prepaid'
               };

               res = await this.$lionheart.post("/v2/dg/payment-confirmation", {
                  ...params,
                  ...this.payment,
               });

               if (res.data?.success === false) {
                  this.challengeError = true;

                  return false;
               }

               return true;
            } else {
               // not sure with this scenario
               res = await this.$refs.payment.createPayment({
                  ...this.payment,
                  pms_reservation_no: this.booking_details.data[0].pms_reservation_no,
                  facility_id: this.facility.id,
                  entry_method: this.page == "checkout" ? 'postpaid' : 'prepaid',
               });
            }

            return res.status;
         }

         return true;
      },
      // to support other payment method it will always return true
      createPaymentMethod() {
         if (!this.initialize) return true;

         const paymentOtherOptions = [
            payment_gateway.reception,
            payment_gateway.payLater,
         ];

         if (paymentOtherOptions.includes(this.payment.gateway)) return true;

         //Check if already authorized and payment gateway is digital_garage
         return (this.payment.gateway == this.payment_gateway.digital_garage && this.payment_authorized);
      },
      async showPaymentTimingOption() {
         const optSettings = await this.$lionheart
            .post("/facility-setting/list", {
               name: "payment_timing_opts",
               facility_id: this.facility.id,
               paginate: false,
            })
            .then((r) => this.catcher(r, "data.total", (r) => (r.data.total > 0 ? r.data.data[0] : r.data)))
            .catch((e) => this.catcher(e));

         if (optSettings.error.has_error) return;

         if (optSettings.total == 0) return;

         this.payment_timing_opt = optSettings.value;
      },
      async showPayment() {
         if (this.payment_timing_opt.waivePay) return (this.show_payment = false);

         const res = await this.$lionheart
            .post("/facility-setting/list", {
               facility_id: this.facility.id,
               name: "payment_option",
               paginate: false,
            })
            .then((r) => this.catcher(r, "data.total", (r) => (r.data.total > 0 ? r.data.data[0] : r.data)))
            .catch((e) => this.catcher(e));

         if (res.error.has_error) {
            if (this.page != "checkin") return (this.show_payment = false);
            return;
         }

         if (res.total == 0) {
            if (this.page != "checkin") return (this.show_payment = false);
            return;
         }

         let showPayment = _.find(res.value, (val, key) => {
            return ["checkin", "deposit"].includes(key) && val == 1;
         });

         if (this.page == "checkout") showPayment = res.value[this.page];

         const isCheckinCheckoutModeEnabled = res.value.mode == 'checkin_and_checkout' && res.value[this.page] == 1;

         if(!isCheckinCheckoutModeEnabled) return (this.show_payment = showPayment);
         this.dual_payment_mode = true;
         return (this.show_payment = true);
      },
      async validatePayment() {
         const paid_statuses = [
            payment_status.pay_at_reception,
            payment_status.paid_authorized,
            payment_status.paid_captured,
            payment_status.paid,
         ];
         

         if (this.booking_details.total == 0) {
            this.initialize = false;
         } else {
            const net_charge = this.booking_details.data[0]?.parsed.net_charge ?? 0;
            const bookingStatus = this.booking_details.data[0]?.booking_status_id ?? '';
            console.log("bookingStatus ", bookingStatus);
            console.log("net_charge ", net_charge);
            console.log("dual_payment_mode ", this.dual_payment_mode);
            console.log("booking_status ", booking_status.pre_check_in);
            if(this.dual_payment_mode) {
               if (paid_statuses.includes(this.booking_details.data[0].payment_status_id) && net_charge == 0 ) {
                  this.initialize = false
               } else if(bookingStatus == booking_status.pre_check_in && net_charge > 0) {
                  console.log("dual payment mode pre checkin and net charge > 0")
                  this.initialize = false
               } else {
                  await this.checkPaymentValidation()
               }
            } else {
               // if guest is paid do not show the payment
               if (paid_statuses.includes(this.booking_details.data[0].payment_status_id)) {
                  this.initialize = false;
                  return;
               }
               await this.checkPaymentValidation()
            }
         }
      },
      async checkPaymentValidation() {
         let paymentConfirmationResult = await this.$lionheart
               .post("/v2/dg/payment-validation", {
                  facility_id: this.facility.id,
                  pms_code: this.booking_details.data[0].pms_code,
                  pms_reservation_no: this.booking_details.data[0].pms_reservation_no,
                  pass: this.booking_details.data[0].pass,
                  currency: this.currency,
                  entry_method: this.page == "checkout" ? 'postpaid' : 'prepaid'
               })
               .then(response => response);

            console.log("paymentConfirmationResult ", paymentConfirmationResult);
            console.log("paymentConfirmationResult status ", paymentConfirmationResult.data.status);

            const status = paymentConfirmationResult.data.status
            //if the status is card pending and paid_captured guest is already paid and captured based on DG
            if ((status == 'paid_authorized' || status === 'paid_captured')) {
               this.initialize = false
               // todo: add note in payment form: "Payment is made pls proceed to submission of form"
            } else {
               this.initialize = true
            }
      },
      reInit() {
         if (!this.show_payment) return;
      },
      async changePaymentMethod($event) { },
      reloadPage() {
         window.location.reload();
      }
   },
   computed: {
      allowCloseBtn() {
         let res;

         if (this.isProcessing && this.challengeError) {
            res = true;
         } else if (!this.isProcessing && this.challengeError) {
            res = false
         } else if (this.isProcessing && !this.challengeError) {
            res = true
         } else if (!this.isProcessing && !this.challengeError) {
            res = false
         } else {
            res = false
         }

         return res;
      },
      iframeUrl() {
         const rsv_no = this.booking_details.data[0]?.pms_reservation_no ?? '<>';
         const pass = this.booking_details.data[0]?.pass ?? '<>';
         const pms_code = this.booking_details.data[0]?.pms_code ?? '<>';
         const net_charge = this.booking_details.data[0]?.parsed.net_charge ?? '<>';
         let email = null;
         if(this.booking.data?.length > 0) { // if already pre checkin and rsv will be checkout it will get from booking store
            email = this.booking.data[0]?.facility_visitor_log?.visitor?.user?.email || this.memorizedEmail || this.booking_details.data[0]?.parsed.email_address || '';
         } else { //if the rsv is reserve status
            email = this.memorizedEmail || this.booking_details.data[0]?.parsed.email_address || '<>';
         }

         Object.assign(this.settings, {
            rsv_no: rsv_no,
            pass: pass,
            pms_code: pms_code,
            facility_id: this.facility.id,
            net_charge: net_charge,
            currency: this.currency,
            email: email,
            entry_method: this.page == "checkout" ? 'postpaid' : 'prepaid'
         });

         const configs = btoa(JSON.stringify(this.settings));
         const slugName = this.facility?.slug_name ?? '';

         const digitalGarageIframeUrl = this.$router.resolve({
            name: 'digital-garage-payment-iframe',
            params: { slug_name: slugName },
            query: { lang: this.$i18n.locale, configs: configs },
         }).href;

         return digitalGarageIframeUrl
      },
      showPayLater() {
         const isPayLater = this.payment_timing_opt.payLaterVisibility &&
            this.page == "checkin" &&
            this.touchdown === undefined;
         const isCameFromPCIHub = this.$route?.query?.pci === 'true' && this.$route?.query?.back === 'true';
         if(isCameFromPCIHub) {
            return isPayLater;
         } else {
            return isPayLater && this.$route.meta?.checkin_phone == null && this.$route.meta?.checkin_name == null;
         }
      },
      
      showOpt() {
         // if(this.page != 'checkout') {
         if (this.payment.gateway === this.payment_gateway.digital_garage) {
            // if(this.page == 'checkout') {
            //    return (this.dual_payment_mode == true);
            // }
            return this.confirm === true ? false : true;
         } else {
            return false
         }
         // }
         // return false
      },
      ...mapGetters("checkin-site", ["booking"]),
      ...mapState('guest', ["paymentAlert"]),
      ...mapState('memorizedInputs', ['memorizedEmail']),
      paymentButtonText() {
         if (this.payment_authorized == true) return this.$t("visit-information-form.card_authorized")
         else return this.$t("visit-information-form.start_payment")
      }
   },
   watch: {
      // show_payment(val) {
      //    // this.$emit("updateShowPayment", val, this.dual_payment_mode);
      //    eventBus.$emit("updateShowPayment", val, this.dual_payment_mode);
      // },
      show_payment: {
         handler(newVal) {
            this.$emit("updateShowPayment", newVal, this.dual_payment_mode);
            eventBus.$emit("updateShowPayment", newVal, this.dual_payment_mode);
         },
         immediate: true // Runs right away on component creation
      },
      confirm(val) {
         if (val == false) {
            if (this.payment_authorized === true) {
               this.setPaymentAlert(true);
            } else {
               this.payment_authorized = false;
            }

            this.challengeError = false;
         }
      },
   },
};
</script>

<style scoped>
.custom-dialog-class {
   display: flex;
   justify-content: center;
   align-items: center;
   overflow-y: auto;
}

.processing-text {
   font-size: 18px;
   font-family: "Poppins", sans-serif;
}

#payment-modal {
   min-height: 80vh;
}

/* .payment-btn {
  background-color: #72d1fc;
  border: none;
} */

.authorized-btn {
   background-color: #eee;
   opacity: 0.5;
   color: #999;
   border: none;
}
</style>
